export const NAVIGATE_BY_NAME_EXTERNAL_EVENT_NAME = "obgNavigate";
export const NAVIGATE_BY_URL_EXTERNAL_EVENT_NAME = "obgNavigateByUrl";
export const NAVIGATE_END_EXTERNAL_EVENT_NAME = "obgNavigationEnd";
